export default {
  lan: 123
}



// WEBPACK FOOTER //
// ./src/store/state.js